import { createSlice } from '@reduxjs/toolkit'
import { ExploreDesignReducer } from './ExploreDesignReducer'
import { useSelector } from 'react-redux'

const initialState = {
    response: {},
    isLoading: false,
    searchSessionId: null,
    searchQuery: null
}

const ExploreDesignSlice = createSlice({
    name: 'exploreDesigns',
    initialState,
    reducers: ExploreDesignReducer
})

export const useExploreDesignsLoading = () =>
    useSelector((state) => state.exploreDesigns.isLoading)

export const useSearchSessionId = () =>
    useSelector((state) => state.exploreDesigns.searchSessionId)

export const useSearchQuery = () =>
    useSelector((state) => state.exploreDesigns.searchQuery)

export const ExploreDesignAction = ExploreDesignSlice.actions

export const useExploreDesigns = () =>
    useSelector((state) => state.exploreDesigns.response)

export default ExploreDesignSlice.reducer
